<template>
    <div>
        <slot v-bind:open="open">
            <a @click="open" class="cursor-pointer p-2 hover:text-blue-dark" :name="item.name">
                <i class="fa fa-pencil"></i>
            </a>
        </slot>

        <portal to="modals" v-if="showModal">
            <modal @close="showModal=false">
                <template slot="header">Edit series {{ item.name }}</template>
                <div>
                    <div class="">
                        <p class="text-grey">series name</p>
                        <input type="text" class="p-2 rounded border border-blue-dark mr-4 w-full" v-model="item.name">
                    </div>

                    <div class="mt-6">
                        <p class="text-grey">unit</p>
                        <input type="text" class="p-2 rounded border border-blue-dark mr-4 w-full" v-model="item.unit">
                    </div>

                    <div class="mt-6">
                        <p class="text-grey">color</p>
                        <label :for="'color-' + index" class="mr-2 cursor-pointer">
                            <i class="fa fa-square" :style="'color: ' + colors[index]"></i>
                        </label>
                        <input :id="'color-' + index" class="hidden" type="color" v-model="colors[index]">
                        <input type="text" v-model="colors[index]" class="p-2 border-blue-dark border rounded">
                    </div>

                    <ul class="list-reset" v-if="isModified">
                        <li class="block my-4">
                            <span class="cursor-pointer hover:text-red border pl-2 pr-2 pt-1 pb-1 text-xs">
                                Original Data
                            </span>
                        </li>
                        <li class="my-4" v-for="(step, stepIndex) in item.steps">
                            <div class="marker"></div>
                            <div class="inline-block border">
                                <a class="flex cursor-pointer hover:text-red pl-2 pr-2 pt-1 pb-1 text-xs"
                                   v-on:click.stop="update('delete', stepIndex)">
                                    <div>{{ step }}</div>
                                    <div class="pl-2"><i class="text-grey-light fa fa-times"></i></div>
                                </a>
                            </div>
                        </li>
                    </ul>

                    <div class="mt-8">
                        <a @click="save()" class="p-2 bg-blue-dark text-white rounded cursor-pointer">
                            <i class="fa fa-save"></i> Save
                        </a>
                    </div>
                </div>
            </modal>
        </portal>

    </div>
</template>

<script>
    export default {

        name: "EditSeries",

        props: ['item', 'index'],

        data: () => ({
            showModal: false,
        }),

        computed: {
            isModified() {
                return this.item.steps.length > 0;
            },
            colors() {
                return this.$store.state.colors;
            },
        },

        methods: {
            open() {
                this.showModal = true;
            },
            save() {
                this.update('modify', {
                    name: this.item.name,
                    unit: this.item.unit,
                });
            },
            update(action, parameters) {
                this.$store.dispatch('update', {action: action, ids: [this.index], parameters: parameters});
            },
        },
    }
</script>

<style scoped>

</style>
